import { keyframes, styled } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const Root = styled.div<{ $minHeight?: string }>`
    ${({ $minHeight }) => $minHeight && `min-height:${$minHeight}`};
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
`;

export const Loader = styled.div`
    box-sizing: border-box;
    width: 64px;
    height: 45px;
    position: relative;
    opacity: 0;
    animation: ${fadeIn} 0.4s ease forwards 0.5s;
`;
